import { Box, Divider, Typography } from "@mui/material";
import { TransForm } from "../common/TransForm/Index";
import { PageTitle } from "../common/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import { setPotSettingList, setSelectedLeagues, setPotSetting } from "../../redux/action";
import { useCallback, useEffect } from "react";
import axios from "axios";
import { base_url } from "../backendurl/url";
import { useState } from "react";
import ModalPopUp from "../common/TransForm/ModalPopUp";
import { Notification } from "../common/Notification";
import NewPotCreate from "../common/jsons/formConfigs/NewPotCreate";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";

export const WaitlistForm = ({ mode, title }) => {
  const { PotSetting, selectedLeagues, PotSettingList } = useSelector(
    (state) => state
  );
  const [popup, setPopup] = useState(false);
  const [notification, setnotification] = useState(false);
  const [errorNotifcation,setErrornotification] = useState(false)

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_uuid } = useParams("user_uuid");
  const [loading, setLoading] = useState(false);
  const [potConfig, setPotConfig] = useState({});
  const [isupdate, setIsupdate] = useState(false);
  const [configData, setConfigdata] = useState();
  const [error, seterror] = useState("");
  const [allFieldDisable, setFieldDisable] = useState(false);
  const [onChangeValue, setonChangeValue] = useState();
  const [potCategoryList, setPotCategoryList] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  console.log(PotSetting, "PotSetting")
  // NEW STATE FOR MATCH WEEK
  const [matchWeekList, setMatchWeekList] = useState([]);
  
  const [saveBtnText, setSaveBtnText] = useState({
    title: "Do you want to save new pot?",
    content:
      "Are you sure, you want to create & save a new pot with given details.",
    btnText: "yes , Save",
  });

  const SubmitConfig = async () => {
    try{
      delete configData.prediction_deadline
      delete configData.adminfee
      await axios.post(`${base_url}/api/pot/pots`, configData, Config);
      navigate("/rounds");
      setPopup(false);
      getPotConfig();
    }
   catch(error){
    RefreshToken(error,setErrorMessage,setErrornotification)
   }
  };

  const onSubmit = async (data, name) => {
    setSaveBtnText({
      title: "Do you want to save new pot category ?",
      content:
        "Are you sure, you want to create & save a new pot category with given details.",
      btnText: "yes , Save",
    });
    console.log(data, "data222")
    // Check if valid match week is selected
    // if (!data.match_week || data.match_week === null) {
    //   setErrorMessage("Please select a valid match week");
    //   setErrornotification(true);
    //   return;
    // }
    
    data.max_pot_value = typeof data.max_pot_value === "string" ? parseFloat(data.max_pot_value.replace(/,/g, "")) : data.max_pot_value;
    data.min_pot_value = typeof data.min_pot_value === "string" ? parseFloat(data.min_pot_value.replace(/,/g, "")) : data.min_pot_value;
    data.value_of_token = typeof data.value_of_token === "string" ? parseFloat(data.value_of_token.replace(/,/g, "")) : data.value_of_token;
    data.deadline_predictions = parseInt(data.prediction_deadline);
    data.admin_fee = parseInt(data.adminfee);
    data.max_active_picks_voting	 = parseInt(data.min_picks_for_splitting);
    data.status = "Waitlist";
    data.current_pot_value = 0;
    data.token_value = data.value_of_token
    data.payment_status = false;
    data.last_entry_time = new Date();
      const picksPerPlayer = parseInt(data.picks_per_player);
  if (picksPerPlayer !== 1 && picksPerPlayer !== 2) {
    setErrorMessage("No. of picks per player has only 1 or 2 picks per player are allowed.");
    setErrornotification(true);
    return; 
  }
    data.max_number_of_picks = data.picks_per_player;
    data.season = data.season;
    data.category = data.pot_category;
    // data.dead_line_voting= parseInt(data.dead_line_voting);
    data.deadline_voting= parseInt(data.dead_line_voting);
    //data.deadline_voting= parseInt(data.deadline_voting);
    // ADD MATCH WEEK ID TO PAYLOAD
    // data.matchweek_id = data.match_week; // This will be the matchweek_id
    data.matchweek_id = data.match_week;
    const selectedMatchWeek = matchWeekList.find(
  (mw) => mw.id === data.match_week
);
data.pot_matchweek = selectedMatchWeek ? selectedMatchWeek.name : null;
    delete data.Submit;
    data.pot_config = PotSetting.id;
    if (data.max_pot_value < data.min_pot_value) {
      setnotification(true);
    } else {
      setPopup(true);
      setnotification(false);
      setConfigdata(data);
    }
  };

  const getPotConfig = useCallback(async () => {
    seterror("");
    setLoading(true);
    setLoading(false);
  }, [PotSetting, user_uuid]);

  //fill data
  const FillPotCategory = async (id) => {
    let potSetting = PotSettingList.find((item) => {
      return item.id == id;
    });
    if (potSetting) {
      potSetting.category = id;
      potSetting.league = onChangeValue;
      delete potSetting.created_at
      delete potSetting.created_by
      delete potSetting.updated_by
      delete potSetting.updated_at
      dispatch(setPotSetting(potSetting));
    }
  };

  // NEW FUNCTION TO GET MATCH WEEKS
  const getMatchWeeks = async (seasonId) => {
    console.log(seasonId, "seasonId")
    try {
      const response = await axios.get(
        `${base_url}/api/pot/seasonmatchweeks?season=${seasonId}&upcoming_only=true`,
        Config
      );
      console.log(response, "response1122")
      // Format the match week data for dropdown
      const matchWeeks = response?.data?.data?.map((item) => {
        return {
          id: item?.matchweek_id,
          name: item?.matchweek || item?.matchweek,
          ...item,
        };
      });
      console.log(matchWeeks, "matchWeeks")
      setMatchWeekList(matchWeeks || []);
    } catch (error) {
      RefreshToken(error, setErrorMessage, setErrornotification);
      setMatchWeekList([]);
    }
  };

  //get league details - UPDATED TO ALSO FETCH MATCH WEEKS
  // const getPotCategory = async (id) => {
  //   try{
  //     setonChangeValue(id);
      
  //     // Clear previous match weeks when changing league
  //     setMatchWeekList([]);
      
  //     // Get pot categories
  //     const response = await axios.get(
  //       `${base_url}/api/pot/potconfigs?season=${id}`,
  //       Config
  //     );

  //     //fill select dropdown
  //     const categoryList = response?.data?.data.map((item) => {
  //       return {
  //         id: item?.pot_category,
  //         name: item?.pot_category,
  //         ...item,
  //       };
  //     });

  //     let fileterdata = categoryList?.filter(item => item.status == "Launched")
  //     dispatch(setPotSettingList(fileterdata));
      
  //     // ALSO GET MATCH WEEKS WHEN SEASON/LEAGUE IS SELECTED
  //     await getMatchWeeks(id);
      
  //   } catch(error){
  //     RefreshToken(error,setErrorMessage,setErrornotification)
  //   }
  // };

  const getPotCategory = async (id) => {
  try {
    setonChangeValue(id);

    // If no season selected, clear category list and return early
    if (!id) {
      dispatch(setPotSettingList([]));
      setMatchWeekList([]);
      return;
    }

    // Clear previous match weeks and pot categories before fetching
    setMatchWeekList([]);
    dispatch(setPotSettingList([]));

    // Get pot categories for this season
    const response = await axios.get(
      `${base_url}/api/pot/potconfigs?season=${id}`,
      Config
    );

    const categoryList = response?.data?.data.map((item) => ({
      id: item?.pot_category,
      name: item?.pot_category,
      ...item,
    }));

    const filteredData = categoryList?.filter(item => item.status === "Launched");
    dispatch(setPotSettingList(filteredData));

    // Also fetch match weeks for this season
    await getMatchWeeks(id);

  } catch (error) {
    RefreshToken(error, setErrorMessage, setErrornotification);
  }
};

  const getConfig = async () => {
    try{
      const response = await axios.get(`${base_url}/api/pot/seasondropdown`, Config);
      dispatch(setPotSetting({}));
console.log(response, "seasondropdown")
      const leaquename = response?.data?.data.map((item) => {
        return {
          id: item?.id,
          name: item?.display_name,
          ...item,
        };
      });

      dispatch(setSelectedLeagues(leaquename));
      setPotCategoryList(leaquename);
    }
    catch(error){
      RefreshToken(error,setErrorMessage,setErrornotification)
    }
  };

  useEffect(() => {
    getConfig();
  }, []);

  return (
    <Box>
      <Box sx={{ px: 6, pt: 3 }} alignContent="center">
        <PageTitle pageTitle={"Create New Round"} />
      </Box>
      <Divider sx={{ mb: 2, height: 4 }} />
      <TransForm
        submitAction={onSubmit}
        data={PotSetting}
        mode={mode}
        cardlength={"threeCard"}
        formInputs={NewPotCreate({
          mode,
          selectedLeagues,
          getPotCategory,
          FillPotCategory,
          PotSettingList,
          tokendisable: isupdate,
          allFieldDisable,
          matchWeekList, // PASS MATCH WEEK LIST TO FORM
          onChangeValue, // PASS SELECTED LEAGUE VALUE TO CONTROL DROPDOWN STATE
        })}
      />
      <ModalPopUp
        openpopup={popup}
        setPopup={setPopup}
        title={saveBtnText.title}
        subTitle={saveBtnText.content}
        onClick={SubmitConfig}
        save={saveBtnText.btnText}
        cancel={"Exit"}
      />
      <Notification
        message={"Min Pot Value Should not be Higher than Max Pot Value"}
        setopen={setnotification}
        type={"error"}
        show={notification}
      />
      <Notification
        message={errorMessage}
        setopen={setErrornotification}
        type={"error"}
        show={errorNotifcation}
      />
    </Box>
  );
};